import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { BoilingPointCalc } from "../components/BoilingPointCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.bp_tool_name()}
        toolPath="/boiling-point-calculator"
      />
      <SciHeader title={m.bp_h1()} intro={m.bp_intro()} />
      <BoilingPointCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.bp_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.bp_ex1(), m.bp_ex2(), m.bp_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.bp_faq_q1(), a: m.bp_faq_a1() },
          { q: m.bp_faq_q2(), a: m.bp_faq_a2() },
          { q: m.bp_faq_q3(), a: m.bp_faq_a3() },
          { q: m.bp_faq_q4(), a: m.bp_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
